// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueAnalytics from 'vue-analytics'
import Meta from 'vue-meta'

import firebase from 'firebase/app'
import 'firebase/auth'
import {config} from './config'

Vue.config.productionTip = false

Vue.use(Meta)
Vue.use(VueAnalytics, {
  id: 'UA-124174608-1',
  router
})

if (!firebase.apps.length) {
  firebase.initializeApp(config.firebaseConfig)
}

/**
 * 匿名Auth認証
 */
firebase.auth().signInAnonymously().then(() => {
  /**
   * 金額に「,（カンマ）」を挿入し、消費税をかけるグローバルメソッド
   * @param { Number } 整形させたい金額
   * @return { String } 整形して消費税をかけた金額文字列
   */
  Vue.filter('formatPrice', function (price, tax) {
    if (!tax || tax === 0) tax = 8
    price = price * (100 + tax) / 100
    return Number(price).toLocaleString()
  })
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    render: h => h(App)
  })
}).catch((error) => {
  return new Error(error.message)
})



// WEBPACK FOOTER //
// ./src/main.js